import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import auth, { LOGOUT } from '../../features/auth/ducks';
import account from '../../features/account-management/ducks';
import dashboard from '../../features/admin-dashboard/ducks';
import spinner from '../../features/spinner/ducks';
import modal from '../../features/modal/ducks';
import files from '../../features/files/ducks';
import loan from '../../features/loan-management/ducks';
import allocations from '../../features/allocations/ducks';
import loans from '../../features/loans/ducks';
import documents from '../../features/documents/ducks';
import allocation from '../../features/allocation-management/ducks';
import payment from '../../features/payment-management/ducks';
import payments from '../../features/payments/ducks';
import messaging from '../../features/messaging-dashboard/ducks';
import settingManagement from '../../features/setting-management/ducks';
import settings from '../../features/settings/ducks';
import landingPage from '../../features/landing-page/ducks';
import accountOverview from '../../features/overview/ducks';
import question from '../../features/help-management/ducks';
import disposals from '../../features/disposals/ducks';
import transactions from '../../features/transactions/ducks';
import penaltyFees from '../../features/penalty-fee/ducks';
import psd2 from '../../features/psd2/ducks';

const rootReducer = combineReducers({
  auth,
  spinner,
  modal,
  account,
  dashboard,
  files,
  loan,
  allocations,
  disposals,
  loans,
  documents,
  allocation,
  payment,
  payments,
  messaging,
  settingManagement,
  settings,
  question,
  landingPage,
  transactions,
  accountOverview,
  penaltyFees,
  psd2,
  routing: routerReducer,
});

export default (state, action) => {
  if (action.type === LOGOUT) {
    return rootReducer({ settings: state.settings }, action);
  }

  return rootReducer(state, action);
};



// WEBPACK FOOTER //
// ./src/app/store/rootReducer.js